export default {
    siteName: '柠檬编程训练平台',
    minSiteMame: 'ADMIN',
    sex: {
        male: '男',
        female: '女',
        unknown: '未知'
    },
    userStatus: {
        0: '启用',
        1: '锁定'
    },
    saleStatus: {
        0: '下架',
        1: '上架'
    }
}